<style lang="scss" scoped>
.SchoolStatus {
	width: 16px;
	height: 16px;
	border-radius: 50%;
}
.offline {
	background: $--danger;
}
.online {
	background: $--success;
}
</style>

<template lang="pug">
    .SchoolStatus(:class="color")
</template>

<script>
export default {
	name: "SchoolStatus",
	props: {
		school: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		color() {
			return this.school.online ? "online" : "offline";
		}
	}
};
</script>
